export default __webpack_public_path__ + "static/media/loginBgimg3.ec373030.svg";